import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const DistrictPolicy = async () => {
    const response = await fetch(`${process.env.REACT_APP_URL_MIS}/api/reports/DistrictPolicy`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (response.status === 204) {
        return [];
    }
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const PolicyDetails = ({ }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    //const [tabHeading, setTabHeading] = useState(heading);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [searchQuery, setSearchQuery] = useState('');
    const [totals, setTotals] = useState([]); // State for storing column totals
    const detailsTrans = useRef(null);

    const calculateTotals = (data) => {

        const columnCount = data[0].scheCommlist.length;
        const columnTotals = new Array(columnCount).fill(0); // Initialize an array for totals

        data.forEach(item => {
            item.scheCommlist.forEach((colItem, colIndex) => {
                columnTotals[colIndex] += parseFloat(colItem.entitlment) || 0; // Sum each column's allot_qty
            });

        });

        setTotals(columnTotals);
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await DistrictPolicy();

                if (Array.isArray(response_data)) {
                    setReportData(response_data);

                    if (response_data.length > 0)
                        calculateTotals(response_data);

                } else {
                    setReportData([]);
                }
            } catch (error) {
                console.log(error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
        setPage(0);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error </div>;
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }

    return (
        <>
            <br /><br />

            <table align="center" width="60%" border={1} ref={detailsTrans}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={4 + reportData[0].scheCommlist.length}>
                            District Wise Policy
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>District</th>
                        {[
                            ...new Map(
                                reportData[0].scheCommlist.map(s => [s.scheme_id, s])
                            ).values()
                        ].map(s => (
                            <th colSpan={(reportData[0].scheCommlist.length)/2} key={s.scheme_id}>
                                {s.scheme_name}
                            </th>
                        ))}
                    </tr>
                    <tr className="tableheader">
                        {reportData[0].scheCommlist.map((item, index) => (
                            <th key={index}>{item.comm_name} <br /> ({item.unity_type})</th>
                        ))}

                    </tr>

                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.receiptId}>
                            <td style={{ textAlign: 'center' }}>{index + 1 + (page * rowsPerPage)}</td>
                            <td style={{ textAlign: 'left' }}>{item.dist_name_en}</td>
                            {item.scheCommlist.map((item1, index) => (
                                <td key={index} style={{ textAlign: 'right' }}>{item1.entitlment || '0'}</td>
                            ))}

                        </tr>
                    ))}

                </tbody>
                <tfoot>
                    <tr className="tableheader">
                        <td colSpan={2}>Total</td>
                        {totals.map((total, index) => (
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total.toFixed(3)}</td>
                        ))}

                    </tr>
                </tfoot>
            </table>
            <br />
            <br />
            <br></br>

        </>
    );
};

export default PolicyDetails;


